import { Provider } from '@angular/core';
import { GetVesselInfoUseCase } from '@app/application/use-cases/vessel-info';
import { VesselInfoRepository } from '@app/domain/repositories/vessel-info.repository';
import { VesselInfoRepositoryImpl } from '../repositories/vessel-info.repository.impl';

export const VESSEL_INFO_PROVIDERS: Provider[] = [
  {
    provide: VesselInfoRepository,
    useClass: VesselInfoRepositoryImpl,
  },
  {
    provide: GetVesselInfoUseCase,
    useFactory: (repo: VesselInfoRepository) => new GetVesselInfoUseCase(repo),
    deps: [VesselInfoRepository],
  },
];
